const { h1, h2, p, kicker, ul, ol, img, note, info, safe, rich, page } = require("./blocks");

const PATHS = {
  en: "/how-to-use-aviatortrends-dashboard",
  es: "/es/como-usar-aviatortrends",
  "pt-BR": "/pt-br/como-usar-aviatortrends",
  "pt-PT": "/pt-pt/como-usar-aviatortrends",
  de: "/de/aviatortrends-dashboard-anleitung",
  it: "/it/come-usare-aviatortrends",
};

const copy = {
  en: page(
    "How to Use AviatorTrends: All Five Analysis Tabs | AviatorTrends",
    "A mobile-friendly walkthrough of Results List, Live AI Forecast, Time Series, Histogram and Payout Flow — without fake guarantees.",
    [
      kicker("Five tabs, one live feed"),
      h1("From Raw Results to a Decision: Using the Five AviatorTrends Tabs"),
      p("Most players experience Aviator one round at a time. After a few minutes, memory is a bad dataset. The dashboard splits the same live feed into five views. None of them can reveal Spribe’s hidden seed. Together they beat impulse."),
      img("spribe-aviator-graphical-analysis", "AviatorTrends dashboard with Results List, Time Series and Histogram", "Start on a phone: list first, then charts."),
      h2("1. Results List"),
      p("See consecutive lows, isolated highs, clusters, the current top multiplier and differences between supported feeds. Change the window. A pattern that dies at 300 points was probably a small sample."),
      img("aviator-round-history", "Round history chips on AviatorTrends", "High results are events. They are not a countdown."),
      h2("2. Live AI Forecast"),
      img("Aviator AIForecast", "AviatorTrends Live AI Forecast models", "Model ranges, agreement and sample counts live in this tab."),
      p("Compare model agreement, likely range, threshold chances, Stop-Loss Accuracy, Win Accuracy and sample counts. The flashiest percentage is not automatically the best row. Check the range, the denominator, Live versus Cached, and whether other models agree."),
      h2("3. Time Series"),
      img("aviator-trends-analysis-timeseries-300", "Time series of Aviator multipliers", "Ask whether spikes are clustered or isolated, and whether the shape survives a longer window."),
      h2("4. Histogram"),
      img("forecast", "Probability distribution and forecast column", "Compare current percentages with the reference. A coloured difference describes the sample. It does not owe you the next bin."),
      h2("5. Payout Flow"),
      img("Aviator Payoutflow", "AviatorTrends Payout Flow chart", "The slope shows whether payout activity is climbing or fading. You can actually tell where the trend will go next."),
      p("A high multiplier is not the same as a large total payout. Stakes, cash-out timing and how many players entered all matter. The rolling average adds context."),
      note("Watch the slope. You can actually tell when payout activity is rising or dropping. A climbing line is a hotter session in the data you already have. A fading line is cooling. That still does not determine the next result."),
      h2("A five-minute workflow"),
      ol([
        "Pick one casino feed",
        "Start at 300 results",
        "Mark unusual events in the list",
        "Check spacing on Time Series",
        "Compare Histogram with the reference",
        "Read model ranges and sample counts",
        "Glance at Payout Flow",
        "Set a budget — or skip the round",
      ]),
      info("Free versus Extended", "Free access explores the live dashboard and a shorter history. Extended Data Access adds up to 5,000 points, live forecasts, a dynamic distribution, larger exports and uninterrupted streams.", [
        "You subscribe to tools and data, not a guaranteed signal",
      ]),
      ul([
        "Results List: what happened",
        "Forecast: what the models estimate",
        "Time Series: when it happened",
        "Histogram: how the sample is distributed",
        "Payout Flow: how much payout activity occurred",
      ]),
      safe("Aviator stays unpredictable at the exact-round level", "That is why honest analysis promises context, not a next-number hack. Going in with a record is still better than going in commando.", []),
      rich("Open the dashboard on ", "/", "AviatorTrends", " or see Extended Data Access on /plans."),
    ]
  ),
  es: page(
    "Cómo usar AviatorTrends: las cinco pestañas | AviatorTrends",
    "Recorrido móvil de Lista, Previsión IA, Serie temporal, Histograma y Flujo de pagos, sin garantías falsas.",
    [
      kicker("Cinco pestañas, un feed en vivo"),
      h1("De los resultados crudos a una decisión: las cinco pestañas"),
      p("La memoria es un mal dataset. El panel parte el mismo feed en cinco vistas. Ninguna revela la semilla oculta. Juntas vencen al impulso."),
      img("spribe-aviator-graphical-analysis", "Panel de AviatorTrends", "En el móvil: lista primero, luego gráficos."),
      h2("1. Lista de resultados"),
      p("Bajos seguidos, altos aislados, racimos y el máximo actual. Si el patrón muere a 300 puntos, era una muestra pequeña."),
      img("aviator-round-history", "Historial de rondas", "Los altos son eventos, no una cuenta atrás."),
      h2("2. Previsión IA en vivo"),
      img("Aviator AIForecast", "Modelos de previsión IA en vivo de AviatorTrends", "Rangos, acuerdo y recuentos viven en esta pestaña, no en el histograma."),
      p("Mira acuerdo, rango, recuento, Live o Cached. El porcentaje más alto no es automáticamente la mejor fila."),
      h2("3. Serie temporal"),
      img("aviator-trends-analysis-timeseries-300", "Serie temporal", "¿Los picos están agrupados? ¿Aguantan una ventana más larga?"),
      h2("4. Histograma"),
      img("forecast", "Distribución y previsión", "La diferencia de color describe la muestra, no te debe el siguiente intervalo."),
      h2("5. Flujo de pagos"),
      img("Aviator Payoutflow", "Gráfico de flujo de pagos de AviatorTrends", "La pendiente muestra si la actividad de pagos sube o baja."),
      p("Un multiplicador alto no es lo mismo que un pago total alto."),
      note("Mira la pendiente. De verdad se ve si la actividad de pagos está subiendo o bajando. Una línea que sube es una sesión más caliente en los datos que ya tienes. Una que se apaga se está enfriando. Eso no determina el siguiente resultado."),
      ol(["Elige un feed", "Empieza en 300", "Marca eventos", "Mira la serie", "Compara el histograma", "Lee rangos y recuentos", "Mira pagos", "Presupuesto — o pasa"]),
      info("Gratis frente a extendido", "El plan de pago añade hasta 5.000 puntos, previsión en vivo y exportaciones mayores.", []),
      safe("Aviator sigue imprevisible en la ronda exacta", "El análisis honesto promete contexto, no un hack del siguiente número.", []),
      rich("Abre el panel en ", "/", "AviatorTrends", "."),
    ]
  ),
  "pt-BR": page(
    "Como usar a AviatorTrends: as cinco abas | AviatorTrends",
    "Um passo a passo no celular: Lista, Previsão IA, Série, Histograma e Fluxo de pagamentos, sem garantia falsa.",
    [
      kicker("Cinco abas, um feed ao vivo"),
      h1("Dos resultados crus a uma decisão: as cinco abas"),
      p("A memória é um dataset ruim. O painel parte o mesmo feed em cinco visões. Nenhuma revela a semente oculta."),
      img("spribe-aviator-graphical-analysis", "Painel da AviatorTrends", "No celular: lista primeiro, depois gráficos."),
      h2("1. Lista de resultados"),
      img("aviator-round-history", "Histórico de rodadas", "Altos são eventos, não uma contagem regressiva."),
      h2("2. Previsão IA ao vivo"),
      img("Aviator AIForecast", "Modelos de previsão IA ao vivo da AviatorTrends", "Intervalos, acordo e contagens ficam nesta aba — não no histograma."),
      p("Veja acordo, intervalo, contagem, Live ou Cached. A maior porcentagem não é automaticamente a melhor linha."),
      h2("3. Série temporal"),
      img("aviator-trends-analysis-timeseries-300", "Série temporal", "Os picos estão agrupados? Sobrevivem numa janela maior?"),
      h2("4. Histograma"),
      img("forecast", "Distribuição e previsão", "A diferença colorida descreve a amostra."),
      h2("5. Fluxo de pagamentos"),
      img("Aviator Payoutflow", "Gráfico de fluxo de pagamentos da AviatorTrends", "A inclinação mostra se a atividade de pagamentos sobe ou cai."),
      p("Multiplicador alto não é o mesmo que pagamento total alto."),
      note("Olhe a inclinação. Dá para ver quando a atividade de pagamentos está subindo ou caindo. Uma linha que sobe é uma sessão mais quente nos dados que você já tem. Uma que some está esfriando. Isso não determina o próximo resultado."),
      ol(["Escolha um feed", "Comece em 300", "Marque eventos", "Veja a série", "Compare o histograma", "Leia intervalos e contagens", "Olhe pagamentos", "Orçamento — ou pule"]),
      info("Grátis versus estendido", "O plano pago adiciona até 5.000 pontos, previsão ao vivo e exportações maiores.", []),
      safe("O Aviator continua imprevisível na rodada exata", "Análise honesta promete contexto, não o próximo número.", []),
      rich("Abra o painel em ", "/", "AviatorTrends", "."),
    ]
  ),
  "pt-PT": page(
    "Como usar a AviatorTrends: os cinco separadores | AviatorTrends",
    "Um guia no telemóvel: Lista, Previsão IA, Série, Histograma e Fluxo de pagamentos, sem garantia falsa.",
    [
      kicker("Cinco separadores, um feed em directo"),
      h1("Dos resultados crus a uma decisão: os cinco separadores"),
      p("A memória é um mau conjunto de dados. O painel parte o mesmo feed em cinco vistas."),
      img("spribe-aviator-graphical-analysis", "Painel da AviatorTrends", "No telemóvel: lista primeiro, depois gráficos."),
      h2("1. Lista de resultados"),
      img("aviator-round-history", "Histórico de rondas", "Os altos são eventos, não uma contagem decrescente."),
      h2("2. Previsão IA em directo"),
      img("Aviator AIForecast", "Modelos de previsão IA em directo da AviatorTrends", "Intervalos, acordo e contagens ficam neste separador — não no histograma."),
      p("Veja acordo, intervalo, contagem, Live ou Cached."),
      h2("3. Série temporal"),
      img("aviator-trends-analysis-timeseries-300", "Série temporal", "Os picos estão agrupados?"),
      h2("4. Histograma"),
      img("forecast", "Distribuição e previsão", "A diferença a cores descreve a amostra."),
      h2("5. Fluxo de pagamentos"),
      img("Aviator Payoutflow", "Gráfico de fluxo de pagamentos da AviatorTrends", "A inclinação mostra se a actividade de pagamentos sobe ou desce."),
      p("Um multiplicador alto não é o mesmo que um pagamento total alto."),
      note("Veja a inclinação. Dá para ver quando a actividade de pagamentos está a subir ou a descer. Uma linha a subir é uma sessão mais quente nos dados que já tem. Uma que se apaga está a arrefecer. Isso não determina o resultado seguinte."),
      ol(["Escolha um feed", "Comece em 300", "Marque eventos", "Veja a série", "Compare o histograma", "Leia intervalos e contagens", "Veja pagamentos", "Orçamento — ou passe"]),
      info("Gratuito versus alargado", "O plano pago acrescenta até 5.000 pontos e previsão em directo.", []),
      safe("O Aviator continua imprevisível na ronda exacta", "A análise honesta promete contexto, não o número seguinte.", []),
      rich("Abra o painel em ", "/", "AviatorTrends", "."),
    ]
  ),
  de: page(
    "AviatorTrends nutzen: alle fünf Analyse-Tabs | AviatorTrends",
    "Ein mobiler Rundgang durch Ergebnisliste, KI-Prognose, Zeitreihe, Histogramm und Auszahlungsfluss — ohne falsche Garantien.",
    [
      kicker("Fünf Tabs, ein Live-Feed"),
      h1("Von Rohdaten zur Entscheidung: die fünf Tabs"),
      p("Das Gedächtnis ist ein schlechtes Dataset. Das Dashboard teilt denselben Feed in fünf Sichten. Keine enthüllt den geheimen Seed."),
      img("spribe-aviator-graphical-analysis", "AviatorTrends-Dashboard", "Am Handy: zuerst die Liste, dann die Charts."),
      h2("1. Ergebnisliste"),
      img("aviator-round-history", "Rundenverlauf", "Hohe Werte sind Ereignisse, kein Countdown."),
      h2("2. Live-KI-Prognose"),
      img("Aviator AIForecast", "Live-KI-Prognosemodelle von AviatorTrends", "Bereiche, Übereinstimmung und Zähler gehören in diesen Tab — nicht ins Histogramm."),
      p("Prüfen Sie Übereinstimmung, Bereich, Zähler, Live oder Cached. Der höchste Prozentsatz ist nicht automatisch die beste Zeile."),
      h2("3. Zeitreihe"),
      img("aviator-trends-analysis-timeseries-300", "Zeitreihe", "Sind Spitzen gebündelt? Überlebt die Form ein längeres Fenster?"),
      h2("4. Histogramm"),
      img("forecast", "Verteilung und Prognose", "Die farbige Differenz beschreibt die Stichprobe."),
      h2("5. Auszahlungsfluss"),
      img("Aviator Payoutflow", "Auszahlungsfluss-Chart von AviatorTrends", "Die Steigung zeigt, ob die Auszahlungsaktivität steigt oder fällt."),
      p("Ein hoher Multiplikator ist nicht dasselbe wie eine hohe Gesamtauszahlung."),
      note("Achten Sie auf die Steigung. Sie können erkennen, ob die Auszahlungsaktivität steigt oder fällt. Eine steigende Linie ist eine heißere Session in den Daten, die Sie schon haben. Eine abflachende Linie kühlt ab. Das bestimmt nicht das nächste Ergebnis."),
      ol(["Feed wählen", "Bei 300 starten", "Ereignisse markieren", "Zeitreihe prüfen", "Histogramm vergleichen", "Bereiche und Zähler lesen", "Auszahlungen ansehen", "Budget — oder aussetzen"]),
      info("Kostenlos gegen erweitert", "Der bezahlte Plan ergänzt bis zu 5.000 Punkte und Live-Prognosen.", []),
      safe("Aviator bleibt in der einzelnen Runde unvorhersehbar", "Ehrliche Analyse verspricht Kontext, nicht die nächste Zahl.", []),
      rich("Öffnen Sie das Dashboard auf ", "/", "AviatorTrends", "."),
    ]
  ),
  it: page(
    "Come usare AviatorTrends: le cinque schede | AviatorTrends",
    "Guida da telefono: Lista, Previsione IA, Serie, Istogramma e Flusso pagamenti, senza garanzie false.",
    [
      kicker("Cinque schede, un feed live"),
      h1("Dai risultati grezzi a una decisione: le cinque schede"),
      p("La memoria è un dataset scarso. La dashboard divide lo stesso feed in cinque viste. Nessuna rivela il seed nascosto."),
      img("spribe-aviator-graphical-analysis", "Dashboard AviatorTrends", "Sul telefono: prima la lista, poi i grafici."),
      h2("1. Lista risultati"),
      img("aviator-round-history", "Cronologia round", "I valori alti sono eventi, non un conto alla rovescia."),
      h2("2. Previsione IA live"),
      img("Aviator AIForecast", "Modelli Live AI Forecast di AviatorTrends", "Intervalli, accordo e conteggi stanno in questa scheda — non nell'istogramma."),
      p("Guarda accordo, intervallo, conteggio, Live o Cached. La percentuale più alta non è automaticamente la riga migliore."),
      h2("3. Serie temporale"),
      img("aviator-trends-analysis-timeseries-300", "Serie temporale", "I picchi sono raggruppati? La forma sopravvive a una finestra più lunga?"),
      h2("4. Istogramma"),
      img("forecast", "Distribuzione e previsione", "La differenza colorata descrive il campione."),
      h2("5. Flusso pagamenti"),
      img("Aviator Payoutflow", "Grafico Payout Flow di AviatorTrends", "La pendenza mostra se l'attività di pagamento sale o scende."),
      p("Un moltiplicatore alto non è lo stesso di un payout totale alto."),
      note("Guarda la pendenza. Si vede quando l'attività di pagamento sta salendo o scendendo. Una linea in salita è una sessione più calda nei dati che hai già. Una che si spegne si sta raffreddando. Non determina il risultato successivo."),
      ol(["Scegli un feed", "Parti da 300", "Segna gli eventi", "Controlla la serie", "Confronta l'istogramma", "Leggi intervalli e conteggi", "Guarda i pagamenti", "Budget — oppure salta"]),
      info("Gratis contro esteso", "Il piano a pagamento aggiunge fino a 5.000 punti e previsioni live.", []),
      safe("Aviator resta imprevedibile sul singolo round", "L'analisi onesta promette contesto, non il numero successivo.", []),
      rich("Apri la dashboard su ", "/", "AviatorTrends", "."),
    ]
  ),
};

module.exports = {
  id: "dashboard",
  paths: PATHS,
  copy,
  hero: "spribe-aviator-graphical-analysis",
  related: ["history", "models", "predict", "guide"],
};
